import React from "react";
import { ButtonGroup, Button, Row, Col } from "react-bootstrap";
import "./tabswitcher.scss";

const TabSwitcher = (props) => {
  let { label = "View By", currentTab, tabs, onTabChange = () => {}, style = {}, className = "", testid } = props;

  return (
    <div style={{ ...style }} className={`${className} mpng-tab-switcher`} data-testid={testid || "mpng-tab-switcher"}>
      <div className="label mt-2">{label} </div>
      <ButtonGroup className="mpng-tab-switcher" aria-label="Choose Report Tab">
        {tabs.map((tab) => {
          return (
            <Button
              key={tab}
              variant={currentTab === tab ? "ilp" : "ilpsecondary"}
              data-testid={currentTab === tab ? "mpng-button-selected" : "mpng-button-unselected"}
              onClick={() => onTabChange(tab)}
            >
              {tab}
            </Button>
          );
        })}
      </ButtonGroup>
    </div>
  );
};

export default TabSwitcher;
